import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/inicio',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/servicios-activos',
    name: 'ActiveServices',
    component: () => import('../views/ActiveServices.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/delivery/:id',
    name: 'DeliveryDetail',
    component: () => import('../views/DeliveryDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/delivery/:id/active',
    name: 'ActiveDelivery',
    component: () => import('../views/ActiveDelivery.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/historial',
    name: 'DeliveryHistory',
    component: () => import('../views/DeliveryHistory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/historial/:id',
    name: 'CompletedDeliveryDetail',
    component: () => import('../views/CompletedDeliveryDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/balance',
    name: 'Balance',
    component: () => import('../views/Balance.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/balance/delivery/:id',
    name: 'BalanceDeliveryDetail',
    component: () => import('../views/BalanceDeliveryDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/balance/pago/:id',
    name: 'PaymentDetail',
    component: () => import('../views/PaymentDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-detail/:id',
    name: 'PaymentDetailSimple',
    component: () => import('../views/PaymentDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notificaciones',
    name: 'Notifications',
    component: () => import('../views/Notifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/delivery/:id/finalizar',
    name: 'FinishDelivery',
    component: () => import('../views/FinishDelivery.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/soporte',
    name: 'Support',
    component: () => import('../views/Support.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation Guards
router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = localStorage.getItem('access_token') || Cookies.get('access_token')

  // Si estamos en la página de login y ya estamos autenticados, redirigir al inicio
  if (to.path === '/login' && isAuthenticated) {
    next('/inicio')
    return
  }

  // Verificar autenticación para rutas protegidas
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
